import styled from 'styled-components';

export const CenterPage = styled.div`
  position: relative;
  margin-top: 0rem;
  //margin-left: -0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CenterBottom = styled.div`
  display: flex;
  position: relative;
  flex: 4;
  margin-bottom: 1rem;
  margin-top: -0.2rem;
  width: 100%;
  height: 4rem;
  .detail-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: space-between;
    justify-content: space-around;
    width: 100%;
    height:6rem;
  //  &-item {
  //    display: flex;
  //    align-items: center;
  //    position: relative;
  //    height: 1.5625rem;
  //    padding: 0 0.125rem;
  //    width: 49%;
  //    border-radius: 5px;
  //    border: 1px solid #343f4b;
  //    background-color: rgba(19, 25, 47, 0.8);
  //    justify-content: center;
  //    img {
  //      width: 1.25rem;
  //      height: 1.25rem;
  //    }
  //    .detail-item-text {
  //      margin-left: 0.125rem;
  //      text-align:center;
  //      h3 {
  //        color: #bcdcff;
  //        font-size: 18px;
  //        margin-top: 0.25rem;
  //      }
  //      span {
  //        font-weight: 500px;
  //        font-size: 0.55rem;
  //        font-weight: bolder;
  //        background: linear-gradient(to bottom, #fff, #4db6e5);
  //        color: transparent;
  //        -webkit-background-clip: text;
  //        background-clip: text;
  //      }
  //      .unit {
  //        font-size: 0.2rem;
  //        margin-left: 0.125rem;
  //      }
  //    }
  //  }
  }
`;

// 新增ChartContainer样式
export const ChartContainer = styled.div`
  width: 100%;
  max-width: 100%; /* 确保在移动端适配 */
  height: 3.9rem; /* 图表高度，可根据需求调整 */
  background-color: rgba(19, 25, 47, 0.8); /* 与现有样式统一背景 */
  border: 1px solid #343f4b;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3); /* 阴影效果 */
  padding: 0.2rem;
  margin-top: 0.5rem; /* 与上方元素间距 */
  padding-right: 1rem;

  /* 响应式适配 */
  @media (min-width: 768px) {
    height: 3.9rem;
    max-width: 90%; /* 桌面端固定最大宽度 */
  }
`;
